import Link from 'next/link';
import AboutUsSlider from 'components/LandingPageAboutUsSlider';
import ReservationForm from '../components/LandingPageReservationForm';
import LandingPageLayout from 'components/LandingPageLayout';
import Professionals from 'components/LandingPageProfessionals';
import WhyUs from 'components/LandingPageWhyUs';
import Head from 'next/head';
import React from 'react';

const FlexibleLease = () => {
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Flexible Lease</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://www.soulrooms.com/flexible-lease" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@SoulRoomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <link rel="canonical" href="https://www.soulrooms.com/flexible-lease" />
      </Head>
      <LandingPageLayout>
        <Professionals
          img={
            <img
              loading="lazy"
              src="/static/images/landingPages/flexible.png"
              width="100%"
              alt="pic"
              className="img img-fluid"
            />
          }
          title={'FLEXIBLE STAY & APPLICATION'}
          description={
            <p
              className="    responsiveText pt-lg-4 pt-md-3 pt-4 pb-2   "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Our leases are designed for your needs, we understand you need flexibility at times specially when you are
              uncertain about work or place to live. Soulrooms offers six month minimum stay lease to help you settle
              <br />
              <p className="mt-5">
                Feel 6 months is long? check out our{' '}
                <Link href="#">
                  <span className="text-decoration-underline" style={{ color: '#D59000', cursor: 'pointer' }}>
                    free transfers{' '}
                  </span>
                </Link>{' '}
                policy which makes us as flexible as a dancing ballerina
              </p>
            </p>
          }
          tagLine="Flex your lease as your muscle"
        />
        {/*  WHY CHOOSE SOULROOMS SECTION  */}
        <WhyUs
          title="FEW OTHER THINGS WE DO TO MAKE IT CONVENIENT FOR YOU"
          heading1="Remote booking & approval"
          detail1="Our booking process and approval process is completely online
           so that you can book a soulroom from anywhere in the world"
          heading2="Consider Non-Canadian finances"
          detail2="New to Canada? we know the pain of getting the applications
           approved by traditional landlords.
           No more paying hefty deposits to get approved, we use smart algorithms 
           to validate your finances from your country"
          heading3="SoulRooms Guarantee"
          detail3="Our post approval SoulRooms Guarantee feature allows you to book
           a SoulRoom well  6 months in advance and get a Room guaranteed at today's 
           price in the hub you selected whenever you move to the city."
          img1="/static/images/landingPages/flexibleCircle1.png"
          img2="/static/images/landingPages/flexibleCircle2.png"
          img3="/static/images/landingPages/flexibleCircle3.png"
        />
        {/* RESERVATION FORM  */}
        <ReservationForm heading="FILL IN YOUR REQUIREMENTS & SEE YOUR SOULROOM OPTIONS">
          <iframe
            id="JotFormIFrame-91797058303261"
            title="Find a SoulRoom"
            onLoad={() => {
              window.parent.scrollTo(0, 0);
            }}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/91797058303261"
            frameBorder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>

        {/* ABOUT US SLIDER  */}
        <AboutUsSlider heading="Featured in:" bg={'black'} />
      </LandingPageLayout>
    </div>
  );
};

export default FlexibleLease;
